















import { Action, Getter } from 'vuex-class';
import {
  Component, Model, Prop, PropSync, Vue, Watch,
} from 'vue-property-decorator';
import DpDialog from '@/components/molecules/DpDialog/index.vue';
import DpInput from '@/components/atoms/DpInput/index.vue';
import DpButton from '@/components/atoms/DpButton/index.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import AuthActionTypes from '@/modules/auth/AuthActionTypes';
import SignUp2 from '@/modules/auth/components/SignUp2/index.vue';

@Component({
  name: 'UnlockAllFeaturesDialog',
  components: {
    SignUp2,
    SvgIcon,
    DpDialog,
    DpInput,
    DpButton,
  },
})
export default class UnlockAllFeaturesDialog extends Vue {
  @Getter('sending', { namespace: 'application' }) protected sending!: boolean;

  @Getter('simpleAuthForm', { namespace: 'auth' }) protected simpleAuthForm!: any;

  protected signUpByAirbnbForm: any = {
    email: null,
    password: null,
  };

  @Action(AuthActionTypes.HIDE_SIMPLE_AUTH_FORM, { namespace: 'auth' })
  protected dispatchHideSimpleAuthForm: any;

  @Action(AuthActionTypes.SIGNUP_BY_AIRBNB, { namespace: 'auth' })
  protected dispatchSignUpByAirbnb: any;

  protected syncedShow: boolean = false;

  @Watch('syncedShow', { immediate: true })
  protected onShowChanged() {
    if (!this.syncedShow) {
      this.dispatchHideSimpleAuthForm();
    }
  }

  @Watch('simpleAuthForm.show', { immediate: true })
  protected onSimpleAuthFormChanged() {
    this.syncedShow = this.simpleAuthForm.show;
  }

  protected onRegister() {
    this.dispatchSignUpByAirbnb(this.signUpByAirbnbForm);
  }
}
